export const userdetails = {
    computed : {
        userToken : {
            get : function () {
                return this.$root.userToken;
            },
            set : function (value) {
                this.$root.setUserToken(value);
            }
        },
        user : {
            get : function () {
                return this.$root.user;
            },
            set : function (value) {
                this.$root.setUser(value);
            }
        },
    },
    methods : {
        logout : function () {
            this.$root.logout();
        }
    }
}